import styled from 'styled-components';

export const DetailWrapper = styled.div`
  flex: 1 1 0;
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const NamePrice = styled(Row)<{ isShowingDetails: boolean }>`
  padding-bottom: ${({ isShowingDetails }) => (isShowingDetails ? '8px' : '16px')};
`;

export const DescriptionWrapper = styled.div`
  display: flex;
  padding-bottom: 24px;
  padding-right: 20px;
`;

export const DescriptionRow = styled(Row)`
  transition: max-height 0.3s ease-in;
  overflow: hidden;
`;

export const MoreDetailsGuestSelect = styled(Row)`
  align-items: flex-end;

  & > *:nth-child(1) {
    transition: margin-bottom 0.3s ease-in;
    flex: 1 1 0;
  }

  & > *:nth-child(2) {
    flex: 1 1 0;
    display: flex;
  }

  & > button:nth-child(2) {
    max-width: 100px;
  }
`;
